import axios from 'axios';
import { get } from '@/_helper/storage.jsx';

export const errorReport = <T>(errorLog: T) => {
    if (window.location.hostname === 'localhost') {
        return false;
    }
    const message = typeof errorLog === 'string' ? errorLog : JSON.stringify(errorLog);

    const sendData = {
        requestType: 'bookingData',
        action: 'logError',
        clientId: 'customerarea',
        requestSource: 'AurumTours-Customerarea',
        hash: get('access_token'),
        data: { message },
    };

    return axios({
        url: window.$serviceUrl + '/bookingData?token=' + window.$token,
        method: 'POST',
        data: sendData,
    })
        .then((response) => response)
        .then(() => {})
        .catch(() => {});
};
